import { ARKON, EXTERNAL_CS, SYSTEMS } from '@/consts/systems.consts';

export const REPORT_CATEGORY_OPTIONS = [
  {
    value: ARKON.CS.REPORTS.CATEGORY.CODES.GENETIC,
    label: ARKON.CS.REPORTS.CATEGORY.CODES.GENETIC,
  },
  {
    value: ARKON.CS.REPORTS.CATEGORY.CODES.INVESTIGATION,
    label: ARKON.CS.REPORTS.CATEGORY.CODES.INVESTIGATION,
  },
  {
    value: ARKON.CS.REPORTS.CATEGORY.CODES.BIOPSY,
    label: ARKON.CS.REPORTS.CATEGORY.CODES.BIOPSY,
  },
] as const;

export const ALL_REPORT_CATEGORY_OPTIONS = [
  {
    value: ARKON.CS.REPORTS.CATEGORY.CODES.GENETIC,
    label: ARKON.CS.REPORTS.CATEGORY.CODES.GENETIC,
  },
  {
    value: ARKON.CS.REPORTS.CATEGORY.CODES.INVESTIGATION,
    label: ARKON.CS.REPORTS.CATEGORY.CODES.INVESTIGATION,
  },
  {
    value: ARKON.CS.REPORTS.CATEGORY.CODES.BIOPSY,
    label: ARKON.CS.REPORTS.CATEGORY.CODES.BIOPSY,
  },
  {
    value: ARKON.CS.REPORTS.CATEGORY.CODES.PRENATAL_CHECK,
    label: 'prenatalCheck',
  },
  {
    value: ARKON.CS.REPORTS.CATEGORY.CODES.PRE_IMPLANTATION_CHECK,
    label: 'preImplantationCheck',
  },
] as const;

export type ReportCategoryValue =
  (typeof ALL_REPORT_CATEGORY_OPTIONS)[number]['value'];

export const REPORT_RESULT_OPTIONS = [
  {
    value: 'NORMAL',
    label: 'normal',
    coding: {
      system: SYSTEMS.SNOMED,
      code: EXTERNAL_CS.SNOMED.CODES.NORMAL_RESULT,
      display: 'Normal result',
    },
  },
  {
    value: 'ABNORMAL',
    label: 'abnormal',
    coding: {
      system: SYSTEMS.SNOMED,
      code: EXTERNAL_CS.SNOMED.CODES.ABNORMAL_RESULT,
      display: 'Abnormal result',
    },
  },
  {
    value: 'NON_SPECIFIC',
    label: 'nonSpecific',
    coding: {
      system: SYSTEMS.SNOMED,
      code: EXTERNAL_CS.SNOMED.CODES.NON_SPECIFIC_RESULT,
      display: 'Indeterminate result',
    },
  },
] as const;

export type ReportResultValue = (typeof REPORT_RESULT_OPTIONS)[number]['value'];

export const REPORT_MODALITY_OPTIONS = {
  BRAIN_OR_ABDOMEN: [
    { value: 'US', label: 'U/S' },
    { value: 'MRI', label: 'MRI' },
    { value: 'CT', label: 'CT' },
  ],
  THORAX: [
    { value: 'US', label: 'U/S' },
    { value: 'MRI', label: 'MRI' },
    { value: 'CT', label: 'CT' },
    { value: 'RO', label: 'Ro' },
  ],
} as const;

export type ReportModalityValue =
  (typeof REPORT_MODALITY_OPTIONS)[keyof typeof REPORT_MODALITY_OPTIONS][number]['value'];
